import { lazy } from 'react';

// After a new deploy changes chunk hashes, a stale tab's dynamic import 404s (served as index.html) and throws a MIME/type error; reload once to pick up the new build instead of leaving the UI broken.
export const lazyWithReload = <T extends { default: React.ComponentType<any> }>(
  importer: () => Promise<T>,
  storageKey: string
) => lazy(() =>
  importer().catch((error) => {
    const alreadyReloaded = sessionStorage.getItem(storageKey) === 'true';

    if (!alreadyReloaded) {
      sessionStorage.setItem(storageKey, 'true');
      window.location.reload();
      return new Promise<T>(() => {});
    }

    sessionStorage.removeItem(storageKey);
    throw error;
  })
);
